import { Calendar } from "antd";
import React from "react";
import { isBetweenPause, isDayToDay } from "../../helpers/dayjsHelper";

const datesColor = {
	today: {
		name: "Día de Hoy",
		color: "#0070D0",
	},
	start: {
		name: "Fecha de Inicio",
		color: "#2DCD6E",
	},
	concluedDate: {
		name: "Fecha de Concluido",
		color: "#07BCD4",
	},
	expectDate: {
		name: "Fecha estimada de entrega",
		color: "#FF9B00",
	},
	deadline: {
		name: "Fecha Límite de Entrega",
		color: "#D93617",
	},
	pause: {
		name: "Día de Pausa",
		color: "#652CB3",
	},
};

const typeForm = {
	day: null,
	dayFormat: null,
	dayFormatYear: null,
};

export const CalendarInfo = ({
	pauses = [],
	dates = {
		today: typeForm,
		start: typeForm,
		concluedDate: typeForm,
		expectDate: typeForm,
		deadline: typeForm,
	},
}) => {
	const dataCellSelect = (value) => {
		let date = value.format("YYYY-MM-DD");

		let isPause = false;
		for (let i = 0; i < pauses.length; i++) {
			const element = pauses[i];
			let tempCloseDate = dates.today;
			if (element.close !== "") {
				tempCloseDate = element.close;
			}
			const isPauseColor = isBetweenPause(date, element.init, tempCloseDate);
			if (isPauseColor) {
				isPause = true;
				break;
			}
		}

		const dateNumber = value.format("D");

		if (isDayToDay(dates.today, date)) {
			return (
				<div className="" style={{ backgroundColor: datesColor.today.color, color: "#fff" }}>
					<p>{dateNumber}</p>
				</div>
			);
		}

		if (isDayToDay(dates.concluedDate, date)) {
			return (
				<div className="" style={{ backgroundColor: datesColor.concluedDate.color, color: "#fff" }}>
					<p>{dateNumber}</p>
				</div>
			);
		}

		if (isDayToDay(dates.start, date)) {
			return (
				<div className="" style={{ backgroundColor: datesColor.start.color, color: "#fff" }}>
					<p>{dateNumber}</p>
				</div>
			);
		}

		if (isDayToDay(dates.deadline, date)) {
			return (
				<div className="" style={{ backgroundColor: datesColor.deadline.color, color: "#fff" }}>
					<p>{dateNumber}</p>
				</div>
			);
		}

		if (isDayToDay(dates.expectDate, date)) {
			return (
				<div className="" style={{ backgroundColor: datesColor.expectDate.color, color: "#fff" }}>
					<p>{dateNumber}</p>
				</div>
			);
		}

		if (isPause) {
			return (
				<div className="" style={{ backgroundColor: datesColor.pause.color, color: "#fff" }}>
					<p>{dateNumber}</p>
				</div>
			);
		}

		return (
			<div className="" style={{ color: "#000" }}>
				<p>{dateNumber}</p>
			</div>
		);
	};

	return (
		<div className="h-full w-full overflow-hidden">
			<Calendar fullscreen={false} dateFullCellRender={(dateCell) => dataCellSelect(dateCell)} />
			<div className="w-full flex flex-col gap-2 mt-2">
				{Object.entries(dates).map(([key, value], index) => (
					<div
						key={`${index}-date`}
						style={{ backgroundColor: datesColor[key].color }}
						className="w-full h-[24px] flex  items-center pl-2 rounded-full text-white font-semibold"
					>
						<p className="text-[12px]">
							{datesColor[key].name}: {value}
						</p>
					</div>
				))}
			</div>
		</div>
	);
};
